import {Template} from '@/interface';
import styles from './index.module.scss';
import Icon, {IconSize} from '@/components/Icon';
import Button from '@/components/Button';
import classNames from 'classnames';
import {forwardRef, memo, useEffect, useMemo, useRef, useState} from 'react';
import {getDocFillSvgByType} from '@/utils/docType';
import tplsSkeletonSvg from '@/assets/svg/tplsSkeleton.svg?tsx';
import {DocNodePreview} from '@/plugins/AIChatPlugin/AigcChat/DocPreview/NodePreview';
import {DocType} from '../useTemplateList';
import EllipsisTooltip from '@/components/EllipsisTooltip';
import {findFirstDiagramInTrees} from '@/utils/docNodeParse';

interface ITemplateCard {
    className?: string;
    openPreview: (templateItem: Template) => void;
    data: Template;
    style?: React.CSSProperties;
    onUseTemplate: (template: Template) => any;
    onClickCard: (template: Template) => any;
    imgBox?: any;
}


const TemplateCard = forwardRef<HTMLDivElement, ITemplateCard>(({
    className,
    data,
    style,
    imgBox = {width: 134, height: 32},
    openPreview,
    onClickCard,
    onUseTemplate,
}: ITemplateCard, ref) => {
    const {name, type, content, docType, rteId} = data;
    const htmlJson = useMemo(() => content?.children, [content?.children]);
    const [docGuid, setDocGuid] = useState('');

    useEffect(() => {
        const json = findFirstDiagramInTrees(htmlJson);
        if (json?.docId) {
            setDocGuid(json.docId);
        } else {
            setDocGuid(rteId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [htmlJson]);

    function handlePreview(e: React.MouseEvent) {
        openPreview && openPreview(data);
        e.stopPropagation();
    }

    const serializeConfig = useMemo(() => {
        return {
            useCover: {
                box: [imgBox.width, imgBox.height],
            },
            hideTitle: true,
            hideCard: !(docType === DocType.card),
            unstable_getTransclusionReferenceSync: () => ({}),
        };
    }, [docType, imgBox]);

    return <div
        ref={ref}
        className={classNames(styles.cardWrap, className)}
        onClick={onClickCard(data)}
        style={style}
    >
        <div className="template-card-item">
            <div className="template-card-title">
                <Icon className="template-icon" svg={getDocFillSvgByType(type)} size={IconSize.XXL} noSpace />
                <EllipsisTooltip
                    className="template-card-name"
                    content={name}
                    placement={'top'}
                >
                    {name || ''}
                </EllipsisTooltip>
            </div>
            <div className="template-card-content">
                {
                    htmlJson && docGuid ?
                        <DocNodePreview
                            className="template-card-content-node"
                            content={htmlJson}
                            serializeConfig={serializeConfig}
                            docGuid={docGuid}
                            disableSecondLoad
                        />
                        : <Icon className="template-card-content-error" svg={tplsSkeletonSvg} size={IconSize.Auto} />
                }
                <div className="template-card-footer">
                    <Button className="template-card-preview-btn" onClick={handlePreview}>预览</Button>
                    <Button className="template-card-use-btn" onClick={onUseTemplate(data)}>使用</Button>
                </div>
            </div>
        </div>
    </div>;
});

export default memo(TemplateCard);
